// 顶栏主题切换 —— 三态循环: system → light → dark → system
// 显当前 resolved 图标：☀ (light) / ☾ (dark) / ◐ (system, 跟随)

import { useEffect, useState } from "react";

import { applyTheme, readTheme, resolvedTheme, type ThemeMode } from "../lib/theme";

export function ThemeToggle() {
  const [mode, setMode] = useState<ThemeMode>(readTheme());
  const [resolved, setResolved] = useState<"light" | "dark">(resolvedTheme());

  useEffect(() => {
    applyTheme(mode);
    setResolved(resolvedTheme());
    // system 模式下监听系统切换
    if (mode === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      const onChange = () => setResolved(resolvedTheme());
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
    return undefined;
  }, [mode]);

  function cycle() {
    setMode((m) => (m === "system" ? "light" : m === "light" ? "dark" : "system"));
  }

  const label =
    mode === "system" ? `跟随系统 · 当前 ${resolved === "dark" ? "深色" : "浅色"}` :
    mode === "light" ? "浅色" : "深色";

  const icon = mode === "system" ? "◐" : mode === "light" ? "☀" : "☾";

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={cycle}
      title={label}
      aria-label={label}
    >
      <span aria-hidden>{icon}</span>
    </button>
  );
}
